
import { AutoMap } from "@automapper/classes";
import { EMesureTerrainStatus } from "./enums/mesure-terrrain-status";

export class ZoneMeasure {
    @AutoMap()
    SamplingId!: number;
    @AutoMap()
    Code!: string;
    @AutoMap()
    IsCancelled!: boolean;
    @AutoMap()
    MeasureReferenceCode!: string;
    @AutoMap()
    MeasureReferenceName!: string;
    @AutoMap()
    Status!: EMesureTerrainStatus;
    @AutoMap()
    Localisation!: string;
    @AutoMap()
    TextColor!: string;
    @AutoMap()
    Color!: string;

    @AutoMap()
    Observation?: string;
    @AutoMap()
    PumpWithBattery!: boolean;

    @AutoMap()
    IsDepose!: boolean;
    @AutoMap()
    HasFan!: boolean;
    @AutoMap()
    SampleCode?: string;
    
    public constructor(init?: Partial<ZoneMeasure>) {
        Object.assign(this, init);
    }
}